import styled from 'styled-components';

export const Card = styled.div<{ backgroundColor?: string; textColor?: string }>`
  display: flex;
  align-items: flex-start;
  background-color: ${(props) => props.backgroundColor || '#fff'};
  color: ${(props) => props.textColor || 'inherit'};
  border-radius: 8px;
  padding: 16px;
  gap: 8px;

  & svg {
    fill: ${(props) => props.textColor || 'inherit'} !important;
  }
`;

export const Message = styled.div`
  font-size: 13px;
`;

export const CardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #00527c;
`;
